import React from 'react';
import { Outlet } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import { Close } from '../../components/Svg/Svg';
import { useSelector } from 'react-redux';
import { getShowGlobalLoader } from '../../redux/slices/appSlice';
import GlobalLoader from '../../components/GlobalLoader';

export default function StartLayout() {
    const showGlobalLoader = useSelector(getShowGlobalLoader);
    return (
        <div>
            <div>
                <Outlet />
            </div>
            <GlobalLoader isLoading={showGlobalLoader} />
            <ToastContainer
                position="top-right"
                autoClose={5000}
                hideProgressBar
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable={false}
                pauseOnHover
                icon={false}
                closeButton={<Close />}
            />
        </div>
    );
}
